import React, { useEffect, useState } from "react";
import { Formik, Form, yupToFormErrors } from "formik";
import { leadVoiceSchema } from "./voiceAddSchema";
import { useDispatch, useSelector } from "react-redux";
import { LeadForm } from "./leadForm";
import { addLead, createMember } from "../../redux/actions/api/apiAction";
import SpinnerComponent from "../spinner/spinner";
import { StepButton } from "./stepButton";
import { getStaffsList } from "../../views/pages/gymPortion/reports/utils";
import { toastr } from "react-redux-toastr";
import { setOpenLeadModal } from "../../redux/actions/lead/leadAction";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

// export const MultiStep = () => {
function LeadMainForm({
  firstName,
  lastName,
  email,
  phone,
  gender,
  edit,
  dob,
  id,
  metaData,
  assignedStaff,
  referralSource,
  priority,
  note,
}) {
  const { loading } = useSelector((state) => state.gym);
  const [step, setStep] = useState(1);
  const [staffList, setStaffList] = useState([]);
  const [defaultAssignedStaff, setDefaultAssignedStaff] = useState(null);
  const dispatch = useDispatch();
  const { loginUser } = useSelector((state) => state.login);
  const { permissions, subAdminType, subAdminPermissions } = useSelector(
    (state) => state.permissions,
  );
  const getStaffListOptions = async () => {
    const staffList = await getStaffsList();
    setStaffList(staffList);
  };
  useEffect(() => {
    getStaffListOptions();
  }, []);
  useEffect(() => {
    if (staffList && staffList.length > 0) {
      let defaultStaff = staffList.find(
        (staff) =>
          staff.value ==
          JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))?.id,
      );
      setDefaultAssignedStaff(defaultStaff || staffList[0]);
    }
  }, [staffList]);
  const handleSubmit = async (values, { setErrors, errors }) => {
    if (saveVoiceDraftEdit(values)) return;
    const {
      firstName,
      lastName,
      email,
      phone,
      gender,
      dob,
      referralSource,
      priority,
      assignedStaff,
      note,
    } = values;
    if (
      !firstName ||
      !lastName ||
      !assignedStaff ||
      (!email && !phone) ||
      !referralSource
    ) {
      return toastr.error("Error", "Please fill all required fields");
    }
    const payload = {
      firstName,
      lastName,
      email,
      phone,
      gender,
      dob,
      priority: priority,
      assignedTo: assignedStaff.value,
      referralSource: referralSource ? referralSource.value : null,
      note,
    };
    const assignedToMe =
      (loginUser.role == "STAFF" && !permissions["LED_VW_AL"]) ||
      (subAdminType == "SUB_ADMIN" && !subAdminPermissions["LED_VW_AL"])
        ? true
        : false;
    dispatch(addLead(payload, assignedToMe));
  };

  const submit = (values, { setErrors }) => {
    if (edit) {
      // handleSubmitForUpdate(values);
    } else {
      handleSubmit(values, { setErrors });
    }
  };

  const previous = () => setStep((step) => step - 1);

  const formSchema1 = leadVoiceSchema;

  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={withVoicePrefill("lead", {
          firstName,
          lastName,
          email,
          phone,
          gender,
          dob,
          id,
          referralSource: referralSource || metaData?.referralSource || "",
          priority: priority || "medium",
          assignedStaff: assignedStaff || defaultAssignedStaff,
          note: note || "",
        })}
        onSubmit={(values, { setErrors }) => {
          submit(values, { setErrors });
        }}
        validationSchema={formSchema1}
      >
        {({
          errors,
          touched,
          values,
          setFieldValue,
          setErrors,
          handleBlur,
          setFieldTouched,
        }) => (
          <Form>
            <LeadForm
              setErrors={setErrors}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              setFieldTouched={setFieldTouched}
              values={values}
              setFieldValue={setFieldValue}
              staffList={staffList}
            />

            <StepButton
              step={step}
              previous={previous}
              edit={edit}
              title="Lead"
              onCancel={() => dispatch(setOpenLeadModal(false))}
            />
          </Form>
        )}
      </Formik>
    </>
  );
}
LeadMainForm.defaultProps = {
  name: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  dob: "",
  id: "",
  handleSubmit: (values) => {},
  edit: false,
  gender: "",
  metaData: {},
};

export default LeadMainForm;
